import { action } from 'mobx';
import stores from 'cd-eft/models/Stores';
const libraryStore = stores.AppStore.projectsLibraryStore;

export class AdvancedSearchVM {
  @action.bound setTrigger() {
    libraryStore.advancedSearchIsOpen = false;
  }

  @action.bound setProjectTypes(e, val) {
    const value = Number(val);
    if (libraryStore.filterProjectTypes.has(value)) {
      libraryStore.filterProjectTypes.delete(value);
      if (libraryStore.filterProjectTypes.size === 0) libraryStore.filterProjectStatuses = new Set();
    } else {
      libraryStore.filterProjectTypes.add(value);
    }
  }

  @action.bound setProjectStatuses(e, val) {
    const value = Number(val);
    if (libraryStore.filterProjectStatuses.has(value)) {
      libraryStore.filterProjectStatuses.delete(value);
    } else {
      libraryStore.filterProjectStatuses.add(value);
    }
  }
}
